var _path, _path2, _g, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2, _circle3, _circle4, _circle5, _path3, _ellipse5, _path4, _path5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.747 167.2C185.112 158.561 172.636 115.365 86.1267 115.365C23.6845 115.365 -4.97473 150.722 1.36126 168.64",
    fill: "url(#paint0_radial_8858_6014)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8858_6014",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 115,
    width: 182,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.747 167.2C185.112 158.561 172.636 115.365 86.1267 115.365C23.6845 115.365 -4.97473 150.722 1.36126 168.64",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8858_6014)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.671968,
    cx: 72.7849,
    cy: 139.589,
    rx: 4.75759,
    ry: 2.64261,
    fill: "url(#paint1_linear_8858_6014)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.451707,
    cx: 123.569,
    cy: 145.941,
    rx: 7.50642,
    ry: 4.12247,
    fill: "url(#paint2_linear_8858_6014)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.469,
    y: 26.1494,
    width: 1.39231,
    height: 12.5308,
    transform: "rotate(13 111.469 26.1494)",
    fill: "url(#paint3_linear_8858_6014)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.727,
    cy: 42.6636,
    rx: 16.3596,
    ry: 11.8346,
    transform: "rotate(13 108.727 42.6636)",
    fill: "url(#paint4_linear_8858_6014)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.116,
    cy: 52.4208,
    rx: 43.8577,
    ry: 15.6635,
    transform: "rotate(13 106.116 52.4208)",
    fill: "#E9EBEC"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.804,
    cy: 53.7782,
    rx: 43.8577,
    ry: 15.6635,
    transform: "rotate(13 105.804 53.7782)",
    fill: "url(#paint5_linear_8858_6014)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.248,
    cy: 61.7607,
    rx: 17.4038,
    ry: 5.91731,
    transform: "rotate(13 103.248 61.7607)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.303,
    cy: 25.6278,
    r: 2.08846,
    transform: "rotate(13 112.303 25.6278)",
    fill: "#D8D8D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.181,
    cy: 55.8943,
    r: 2.78462,
    transform: "rotate(13 138.181 55.8943)",
    fill: "#F9FDFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.7431,
    cy: 42.2723,
    r: 2.78462,
    transform: "rotate(13 97.7431 42.2723)",
    fill: "#F9FDFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.77,
    cy: 47.1258,
    r: 2.78462,
    transform: "rotate(13 118.77 47.1258)",
    fill: "#F9FDFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.454,
    cy: 41.6434,
    r: 2.78462,
    transform: "rotate(13 76.454 41.6434)",
    fill: "#F9FDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.098 66.0069C120.143 65.8991 120.179 65.7883 120.205 65.6744C120.94 62.4901 113.944 58.1559 104.579 55.9937C95.213 53.8315 87.0248 54.6601 86.2896 57.8444C86.2633 57.9582 86.2469 58.0736 86.2402 58.1902L86.2111 58.1835L51.3524 125.966L112.4 140.06L120.127 66.0136L120.098 66.0069Z",
    fill: "url(#paint6_linear_8858_6014)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.328544,
    cx: 91.3468,
    cy: 122.675,
    rx: 12.1827,
    ry: 2.43654,
    fill: "url(#paint7_linear_8858_6014)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8786 104.009C40.8786 104.009 45.1814 111.575 46.2572 116.917C46.2572 121.186 43.5679 122.296 40.8786 122.296C38.1893 122.296 35.5 121.186 35.5 116.917C36.5757 112.077 40.8786 104.009 40.8786 104.009Z",
    fill: "#E8EAEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8789 119.194C40.8789 119.002 41.0347 118.846 41.227 118.846C41.4192 118.846 41.5751 119.002 41.5751 119.194V129.288H40.8789V119.194Z",
    fill: "#D2D6D8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.796852
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.597 101.83C136.597 101.83 140.093 107.965 140.967 112.297C140.967 115.757 138.782 116.658 136.597 116.658C134.412 116.658 132.227 115.757 132.227 112.297C133.101 108.372 136.597 101.83 136.597 101.83Z",
    fill: "#E8EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.598 114.143C136.598 113.987 136.724 113.86 136.88 113.86C137.037 113.86 137.163 113.987 137.163 114.143V122.327H136.598V114.143Z",
    fill: "#D2D6D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8858_6014",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.0003 133.841) rotate(-90) scale(30.9753 323.506)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536775,
    stopColor: "#EBEDF0",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E7",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8858_6014",
    x1: 68.9555,
    y1: 138.888,
    x2: 70.4049,
    y2: 141.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8858_6014",
    x1: 117.266,
    y1: 145.555,
    x2: 119.918,
    y2: 151.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8858_6014",
    x1: 113.343,
    y1: 26.1861,
    x2: 111.514,
    y2: 26.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8858_6014",
    x1: 82.5875,
    y1: 48.9374,
    x2: 113.117,
    y2: 58.5674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8858_6014",
    x1: 45.647,
    y1: 81.9813,
    x2: 90.4438,
    y2: 31.5027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8858_6014",
    x1: 109.45,
    y1: 131.83,
    x2: 132.556,
    y2: 57.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8858_6014",
    x1: 82.2023,
    y1: 122.964,
    x2: 86.4121,
    y2: 131.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsEmptyState);
export default __webpack_public_path__ + "static/media/deals-empty-state.5a46eb6750f3e55d8aaa4340bbabe173.svg";
export { ForwardRef as ReactComponent };